export const Sparkle = ({ className = "", fast = false, size = 18 }) => (
  <svg
    aria-hidden="true"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    className={`${fast ? "sparkle-float-fast" : "sparkle-float"} ${className}`}
  >
    <path
      d="M12 0C12.9 7.2 16.8 11.1 24 12 16.8 12.9 12.9 16.8 12 24 11.1 16.8 7.2 12.9 0 12 7.2 11.1 11.1 7.2 12 0Z"
      fill="#CCFF02"
    />
  </svg>
);
